import { render, staticRenderFns } from "./BackPostDoubleCrochetIcon.vue?vue&type=template&id=2def8128&scoped=true"
import script from "./BackPostDoubleCrochetIcon.vue?vue&type=script&lang=js"
export * from "./BackPostDoubleCrochetIcon.vue?vue&type=script&lang=js"
import style0 from "./BackPostDoubleCrochetIcon.vue?vue&type=style&index=0&id=2def8128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2def8128",
  null
  
)

export default component.exports